// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YEAOo","content":"styles_content__2dVo6"};